import { useRemoveMemberTeamRemoveDeleteMutation } from '@shared/api';

export const useDeleteTeamMember = (organizationId: number, onError?: () => void) => {
  const [deleteTeamMemberMutation, { isLoading }] = useRemoveMemberTeamRemoveDeleteMutation();
  const deleteTeamMember = async (memberId: number) => {
    try {
      await deleteTeamMemberMutation({
        bodyRemoveMemberTeamRemoveDelete: {
          organization_id: organizationId,
          user_id: memberId,
        },
      }).unwrap();
    } catch {
      onError?.();

      throw new Error();
    }
  };

  return { deleteTeamMember, isLoading };
};
